<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm7>
              <div class="x-text-field">
                <label>论著名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm5>
              <div class="x-text-field">
                <label>校内主管部门</label>
                <div>{{item.adminDept? item.adminDept.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>作者列表</label>
                <div>
                  <v-data-table
                    class="dense"
                    :headers="headers"
                    :items="item.authors"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{props.item.rank}}</td>
                      <td>{{props.item.name}}</td>
                      <td>{{props.item.wordCount ? props.item.wordCount : ''}}</td>
                      <td>{{props.item.deptName ? props.item.deptName : '' }}</td>
                      <td>{{props.item.type ? props.item.type.name : '' }}</td>
                    </template>
                  </v-data-table>
                </div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>ISBN</label>
                <div>{{item.isbn}}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>署名情况</label>
                <div>{{ item.named ? '署名' : '未署名' }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>论著类别</label>
                <div>{{ item.type ? item.type.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>论著级别</label>
                <div>{{ item.level ? item.level.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs2>
              <div class="x-text-field">
                <label>总字数(万字)</label>
                <div>{{ item.wordCount }}</div>
              </div>
            </v-flex>

            <v-flex xs5>
              <div class="x-text-field">
                <label>论著属性</label>
                <div>{{ item.subjectType ? item.subjectType.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs5>
              <div class="x-text-field">
                <label>所属学科</label>
                <div>{{ item.subject ? item.subject.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs8>
              <div class="x-text-field">
                <label>出版单位</label>
                <div>{{ item.publisher }}</div>
              </div>
            </v-flex>

            <v-flex xs4>
              <div class="x-text-field">
                <label>出版时间</label>
                <div>{{ item.publDate }}</div>
              </div>
            </v-flex>

            <v-flex xs9>
              <div class="x-text-field">
                <label>归属部门</label>
                <div>{{ item.department? item.department.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>出版地</label>
                <div>{{ item.address }}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

            <v-flex
              xs12
              v-if="item.attachments && item.attachments.length > 0"
            >
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`/api/awar/file/${a.dbid}`" target="_blank">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/book/book';

  export default {
    mixins: [mixin.view(baseUri)],

    data() {
      return {
        item: {},

        headers: [
          {text: '排序', sortable: false, value: 'rank', width: 18},
          {text: '姓名', sortable: false, value: 'name'},
          {text: '完成字数', sortable: false, value: 'wordCount'},
          {text: '单位或部门', sortable: false, value: 'deptName'},
          {text: '类别', sortable: false, value: 'type'},
        ],
      }
    }
  }
</script>
